import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import { Inertia } from '@inertiajs/inertia';
import ProfileCard from '../../Shared/ProfileCard';
import DataCard from '../../Shared/DataCard';
import LoadingButton from '../../Shared/LoadingButton';
import axios from 'axios';

const DeactivateAccountCard = () => {
     const { auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [saved, setSaved] = useState(false);

     const [values, setValues] = useState({
          status: auth.user.is_active,
          color: (auth.user.is_active)?'red':'emerald',
          btnText: (auth.user.is_active)?'De-Activate Account':'Re-Activate Account'
     });

     function handleSubmit(e) {
          e.preventDefault();
          setSending(true);
          Inertia.post(route('profile.activate', data.id), values).then(() => {
               setSending(false);
          });
     }
     return (
          <React.Fragment key="uprofile">
               <Helmet>
                    <title>Profile</title>
               </Helmet>
               <ProfileCard>
                    <div className="md:col-span-1">
                         <div className="px-4 sm:px-0">
                              <h3 className="text-lg font-medium text-gray-900">De-Activate Account</h3>
                              <p className="mt-1 text-sm text-gray-600">
                                   If you really want to de-activate your account, yo may do so. Please keep in my you may re-activate it at anytime
                              </p>
                         </div>
                    </div>
                    <DataCard>
                         <form onSubmit={handleSubmit}>
                              <div className="px-4 py-5 sm:p-6">
                                   <div className="grid grid-cols-6 gap-6">
                                        <div className="col-span-6 sm:col-span-4">
                                             <LoadingButton type="submit" loading={sending} className={`inline-flex items-center px-4 py-2 bg-${values.color}-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-${values.color}-800 focus:outline-none focus:border-red-900 focus:shadow-outline-${values.color} disabled:opacity-25 transition ease-in-out duration-150 ml-4`}>
                                                  {values.btnText}
                                             </LoadingButton>
                                        </div>
                                   </div>
                              </div>
                         </form>
                    </DataCard>
               </ProfileCard>
          </React.Fragment>
     );
};

export default DeactivateAccountCard;
